import { render, staticRenderFns } from "./menuItemCard.vue?vue&type=template&id=17cb4e46&scoped=true&"
import script from "./menuItemCard.vue?vue&type=script&lang=js&"
export * from "./menuItemCard.vue?vue&type=script&lang=js&"
import style0 from "./menuItemCard.vue?vue&type=style&index=0&id=17cb4e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cb4e46",
  null
  
)

export default component.exports